<div class="d-flex flex-row">
<div class="logo border">
<!--          <img src="../../assets/images/logo.png"  class="w-100 he-100">-->
          <div *ngIf="!reportService" class="d-flex align-items-left justify-content-center">
            <i class="fas fa-cloud-upload-alt"></i>
            <span class="ml-2">Upload logo</span>
          </div>
          <div *ngIf="reportService" class="d-flex align-items-left justify-content-center">
            <img  alt="logo" class="img img-fluid" />
          </div>
 </div>
<div class="d-flex flex-column">
<!--          <img src="../../assets/images/logo.png"  class="w-100 he-100">-->
          <div class="d-flex justify-content-center" style="font-size: 15px; font-weight: bold;">
            <label>Company Name</label><app-editable [text]="text" (edited)="text = $event"></app-editable>
          </div>
          <div class="d-flex justify-content-center" style="font-size: 15px; font-weight: bold;">
            <label>Company Address</label><app-editable [text]="text" (edited)="text = $event"></app-editable>
          </div>
        </div>
<div class="d-flex flex-column">
		<div class="d-flex justify-content-center" style="font-size: 15px; font-weight: bold;">
            <label>Project Name</label><app-editable [text]="text" (edited)="text = $event"></app-editable>
          </div>
          <div class="d-flex justify-content-center" style="font-size: 15px; font-weight: bold;">
            <label>Project No.</label><app-editable [text]="text" (edited)="text = $event"></app-editable>
          </div>
          <div class="d-flex justify-content-center"  style="font-size: 15px; font-weight: bold;">
            <label>Date</label><app-editable [text]="text" (edited)="text = $event"></app-editable>
          </div>
</div>
		
<hr>
</div>
